import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Envelope, SelectorOption } from 'types';
import { EnvelopeStatus } from 'types/Envelope';

import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import EnvelopesListRecentsSectionTable from './EnvelopesListRecentsSectionTable';
import EnvelopesListRecentsSectionFilters from './EnvelopesListRecentsSectionFilters';

type EnvelopeWithStatus = Envelope & { envelopeStatus?: EnvelopeStatus };

type EnvelopesRecentsSectionProps = {
  envelopes: EnvelopeWithStatus[];
  envelopesTotal: number;
  serverPage?: number;
  serverRowsPerPage?: number;
  status: SelectorOption | null;
  signatureType: SelectorOption | null;
  onRefresh?: () => Promise<void>;
  onServerPageChange?: (page: number) => void; // eslint-disable-line no-unused-vars
  onServerRowsPerPageChange?: (limit: number) => void; // eslint-disable-line no-unused-vars
  onStatusChange: (option: SelectorOption | null) => void; // eslint-disable-line no-unused-vars
  onSignatureTypeChange: (option: SelectorOption | null) => void; // eslint-disable-line no-unused-vars
};

const EnvelopesListRecentsSection: FC<EnvelopesRecentsSectionProps> = ({
  envelopes,
  envelopesTotal,
  serverPage,
  serverRowsPerPage,
  onServerPageChange,
  onServerRowsPerPageChange,
  onRefresh,
  status,
  signatureType,
  onStatusChange,
  onSignatureTypeChange,
}) => {
  const { t } = useTranslate();

  // Extract envelopes and envelopesStatus from the merged structure
  const envelopesList = envelopes.map((env) => ({
    _id: env._id,
    envelopeId: env.envelopeId,
    author: env.author,
    society: env.society,
    type: env.type,
    status: env.status,
    boardId: env.boardId,
    signers: env.signers,
    document: env.document,
    creationDate: env.creationDate,
  }));

  const envelopesStatus = envelopes
    .map((env) => env.envelopeStatus)
    .filter(Boolean) as EnvelopeStatus[];

  return (
    <>
      <PageListHeader
        subTitle={t('RecentSignatures')}
        subTitleClassName="fs-24px"
        actions={[
          <EnvelopesListRecentsSectionFilters
            status={status}
            signatureType={signatureType}
            onStatusChange={onStatusChange}
            onSignatureTypeChange={onSignatureTypeChange}
          />,
        ]}
        {...{ id: 'envelopes-list-recents-section' }}
      />

      <div className="nk-block envelope-recents-section">
        <div className="card bg-lighter rounded-xl">
          <EnvelopesListRecentsSectionTable
            envelopes={envelopesList}
            envelopesStatus={envelopesStatus}
            envelopesTotal={envelopesTotal}
            serverPage={serverPage}
            serverRowsPerPage={serverRowsPerPage}
            onServerPageChange={onServerPageChange}
            onServerRowsPerPageChange={onServerRowsPerPageChange}
            onRefresh={onRefresh}
          />
        </div>
      </div>
    </>
  );
};

export default EnvelopesListRecentsSection;
